<template>
  <div class="system_message flex flexcolumn scroll_y hidden_scroll">
    <div class="read_all flex FlexjustifyEnd p-20">
      <el-button
        :type="messageNum ? 'success' : 'info'"
        :disabled="messageNum == 0"
        @click="readAllMessage"
        >全部已读</el-button
      >
    </div>
    <div class="message_list p-20" v-if="messageList.length">
      <div
        class="message_one py-15 px-20 mb-20"
        v-for="(item, index) in messageList"
        :key="index"
      >
        <div class="message_date flex Flexalign FlexBetween">
          <div>{{ item.title }}</div>
          <div>{{ item.sendTime }}</div>
        </div>
        <div class="sub_content">{{ item.content }}</div>
      </div>
    </div>
    <div v-else>
      <moe-empty url="moe_empty_bg_img.png" emptyText="暂无系统消息"></moe-empty>
    </div>
  </div>
</template>

<script>
import emitter from "@/utils/emitter";
export default {
  name: "GjkcH5SystemMessage",

  data() {
    return {
      messageList: [],
      listQuery: {
        platform: "wxy_pc", // 适用平台渠道（对应后台字典user_message_scene
        // platforms:'wxy_pc',  // 适用平台渠道（多选，platform和此项只传一个
        sceneType: "system", // 站内信消息场景（对应后台字典user_message_scene）
      },
      messageNum: 0,
    };
  },

  mounted() {
    this.getStationMessageList();
    this.getStationUnReadNum();
  },

  methods: {
    getStationMessageList() {
      this.$Api.message
        .getStationMessageList(this.listQuery)
        .then((res) => {
          this.messageList = res.data.data.list;
        })
        .catch(() => {});
    },
    /**
     * 获取站内信未读数量；与顶栏/IM 侧栏不一致时通过 station-unread-sync 以本接口为准对齐
     */
    getStationUnReadNum() {
      let listQuery = {
        platform: "wxy_pc",
      };
      this.$Api.message
        .getStationUnReadNum(listQuery)
        .then((res) => {
          const total = Number(res?.data?.data?.total ?? 0);
          this.messageNum = total;
          emitter.emit("station-unread-sync", { total });
        })
        .catch(() => {});
    },
    // 全部已读
    readAllMessage() {
      this.$Api.message
        .readAllStationMessage(this.listQuery)
        .then(() => {
          this.$Dialog.toast("已将全部消息设置为已读");
          this.getStationUnReadNum();
          emitter.emit("unread-status-changed");
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.system_message {
  width: 1000px;
  height: 780px;
  background: #ffffff;
  border-radius: 10px;
  .read_all {
    padding-bottom: 0;
  }

  .message_list {
    .message_one {
      background: #fafafa;
      border-radius: 12px;
      .message_date {
        font-weight: 500;
        font-size: 16px;
        color: #303030;
      }
      .sub_content {
        font-weight: 500;
        font-size: 14px;
        color: #606060;
        line-height: 22px;
      }
    }
  }
}
</style>
